import { render, staticRenderFns } from "./no-footer.vue?vue&type=template&id=3dd83339&scoped=true&lang=pug&"
import script from "./no-footer.vue?vue&type=script&lang=js&"
export * from "./no-footer.vue?vue&type=script&lang=js&"
import style0 from "./no-footer.vue?vue&type=style&index=0&id=3dd83339&prod&lang=scss&"
import style1 from "./no-footer.vue?vue&type=style&index=1&id=3dd83339&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd83339",
  null
  
)

export default component.exports